<div class="results-layout">
  <!-- views -->
  <section class="results-content" [style.margin]="currentView === ResultsViews.RESULTS_TABLE ? '0px' : '2px'">
    @if (currentView === ResultsViews.RESULTS_TABLE) {
      <abc-opath-queries-editor-results-table
        [resultsEmpty]="resultsEmpty"
      ></abc-opath-queries-editor-results-table>
    }
    @if (currentView === ResultsViews.RESULTS_JSON) {
      <abc-opath-queries-editor-results-json
        [resultsEmpty]="resultsEmpty"
      ></abc-opath-queries-editor-results-json>
    }
    @if (currentView === ResultsViews.RESULTS_XML) {
      <abc-opath-queries-editor-results-xml
        [resultsEmpty]="resultsEmpty"
      ></abc-opath-queries-editor-results-xml>
    }
    @if (currentView === ResultsViews.RESULTS_QUERY_XML) {
      <abc-opath-queries-editor-results-query-xml
      ></abc-opath-queries-editor-results-query-xml>
    }
    @if (currentView === ResultsViews.RESULTS_QUERY_JSON) {
      <abc-opath-queries-editor-results-query-json
      ></abc-opath-queries-editor-results-query-json>
    }
  </section>

  <!-- footer -->
  <section class="results-footer" [style.height.px]="uiSettings.RESULT_HEADER_HEIGHT">
    <div class="buttons-container">
      <abc-button
        class="control-button"
        [class.active]="currentView === ResultsViews.RESULTS_TABLE"
        [stylingMode]="'text'"
        type="normal"
        [icon]="'fieldchooser'"
        text="{{ translation?.tableResult }}"
        (onClick)="navigateTo(ResultsViews.RESULTS_TABLE)"
      ></abc-button>
      <abc-button
        class="control-button"
        [class.active]="currentView === ResultsViews.RESULTS_JSON"
        [stylingMode]="'text'"
        type="normal"
        [icon]="'alignjustify'"
        text="{{ translation?.jsonResult }}"
        (onClick)="navigateTo(ResultsViews.RESULTS_JSON)"
      ></abc-button>
      <abc-button
        class="control-button"
        [class.active]="currentView === ResultsViews.RESULTS_XML"
        [stylingMode]="'text'"
        type="normal"
        [icon]="'variable'"
        text="{{ translation?.xmlResult }}"
        (onClick)="navigateTo(ResultsViews.RESULTS_XML)"
      ></abc-button>
      <abc-button
        class="control-button"
        [class.active]="currentView === ResultsViews.RESULTS_QUERY_XML"
        [stylingMode]="'text'"
        type="normal"
        [icon]="'exportxlsx'"
        text="{{ translation?.displayXmlQuery }}"
        (onClick)="navigateTo(ResultsViews.RESULTS_QUERY_XML)"
      ></abc-button>
      <abc-button
        class="control-button"
        [class.active]="currentView === ResultsViews.RESULTS_QUERY_JSON"
        [stylingMode]="'text'"
        type="normal"
        [icon]="'textdocument'"
        text="{{ translation?.displayJsonQuery }}"
        (onClick)="navigateTo(ResultsViews.RESULTS_QUERY_JSON)"
      ></abc-button>
    </div>
  </section>
</div>
